import { globalModalPlugin } from '~/composables/useGlobalModal'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(globalModalPlugin)
})
